define([
	"dojo/_base/declare",
	"csi",
	"csi/_base/underscore",
	"csi/table/AggregateFrom"
], function(declare,csi,_,AggregateFrom) {

	return declare(AggregateFrom, {
		/**
		 * @Override
		 * Greys out materials that are already available on this season
		 */
		onCreatePopup: function(view) {
			var tableResults = this.widget.get("store").getResults();
			var urlMap = csi.hashArray(tableResults, null, Boolean);

			this._connectEvent(view, "onViewResults", function(qr, results) {
				_.each(results, function(result) {
					if (urlMap[result.$URL]) {
						view.defView.m_formData.addAggregatedNode(result);
					}
				});
			});

			this.inherited(arguments);
		},

		/**
		 * @Override
		 * The table shows materials, but the operation returns material seasonal availability nodes. In order to display properly the appended urls need to
		 * be replaced by the materials that are referenced.
		 */
		postProcessSuccess: function() {
			var cache = this.getCache();

			this.urlsAppended = _.map(this.urlsAppended, function(url) {
			    return cache.get(url).AvailabilityProduct;
			});

			this.inherited(arguments);
		}
	});
});
